/**
 * Escapes HTML special characters to prevent XSS when injecting values
 * into innerHTML, whether as text content or inside a quoted attribute.
 *
 * Text-node serialization (the div/innerHTML round-trip) only escapes
 * &, <, > — it leaves quotes alone since they're inert in text content.
 * Callers interpolate into both double- and single-quoted attributes as
 * well as text, so an unescaped `"` or `'` in the source value could
 * close the attribute early and inject a new one. Escape quotes
 * explicitly on top of the text-node escaping to cover every context.
 */
export function escapeHTML(str) {
  const div = document.createElement("div");
  div.appendChild(document.createTextNode(str));
  return div.innerHTML.replaceAll('"', "&quot;").replaceAll("'", "&#39;");
}
